//#region src/modules/ServicePeriods/queries/partition-open-instances.ts
function partitionOpenInstances(instances, nowIso) {
	const current = [];
	const upcoming = [];
	instances.forEach((instance) => {
		if (instance.startsAt <= nowIso) current.push(instance);
		else upcoming.push(instance);
	});
	return {
		current,
		upcoming
	};
}
//#endregion
export { partitionOpenInstances };

//# sourceMappingURL=partition-open-instances.js.map